import { supabase } from "@/lib/supabase/supabaseClient";
import { useRetrieveProjectProps } from "./useRetrieveProject.types";

export const retrieveProject = async (project_id: useRetrieveProjectProps) => {
    return await supabase.from('project').update({ archived: false }).eq('id', project_id).select();
}
